import {
  // 批量举报虚假商户的查询上传进度
  getUploadFileProgress,
  // 提交虚假商户的文件
  submitMultiFakeInfo,
  // 批量举报虚假商户文件下载列表
  getMultiFakeInfoList,
  // 批量举报虚假商户文件下载列表中的下载按钮请求
  downloadMultiFakeInfoFile,
} from '@/services/api';
import router from 'umi/router';
import { notification } from 'antd';

const baseInfoErrorHandler = async ({ code, msg = '', data = {} }) => {
  notification.error({
    message: '网络请求失败',
    description: msg,
    duration: 0,
  });
};

export default {
  namespace: 'multiFake',

  state: {

    // 批量上传虚假门店
    uploadInfo: {
      statusCode: null,
      fileUrl: null,
      chunks: null,
      msg: '',
      uploading: false,
    },

    // 批量上传虚假门店文件下载
    multiFakeInfo: {
      pagination: {
        total: 0,         // 总的item数量
        current: 0,       // 当前第几页
        pageSize: 20,     // 每页多少条内容
      },
      loading: false,     // 是否加载中
      /*
      fakeInfoList:
      [
        {
          serialNum	    number	    序号
          fileName	    string	    文件名
          fileUrl	      string	    文件URL
          batchCount	  number	    批次记录数
          submitTime	  number	    提交时间，单位毫秒
          submitter	    string	    提交人
        },
        ...
      ]
       */
      fakeInfoFileList: [], // 具体内容
    },
  },

  effects: {

    // 开始提交虚假商户文件
    * submitMultiFakeInfo({ payload }, { call, put }) {
      yield put({type:'setMultiFakeInfoUploading', payload:true});
      const { code, data, msg } = yield call(submitMultiFakeInfo, payload);
      if (code === 200 && data && data.batchId) {
        yield put({ type: 'clearUploadResult' });
        yield put({type:'setMultiFakeInfoUploading', payload:false});
        yield put({
          type: 'success/setSuccessField',
          payload: {
            flowId: data.batchId,
            successTextHtml: msg,
          },
        });
        router.push('/result/success');
      } else {
        yield put({type:'setMultiFakeInfoUploading', payload:false});
        baseInfoErrorHandler({ code, data, msg });
      }
    },

    // 查询文件上传进度
    * requireUploadProgress({ payload }, { call, put }) {
      yield put({type:'setMultiFakeInfoUploading', payload:true});
      const response = yield call(getUploadFileProgress, payload,
        baseInfoErrorHandler);
      if (response) {
        // response.statusCode -> 0：上传成功, 1：上传中, 2：上传失败

        if (response.statusCode === 1) {
          // 上传中，轮训结果
          setTimeout(() => {
            this.requireUploadProgress({ payload }, { call, put });
          }, 2000);
        } else if (response.statusCode === 0) {
          //成功
          yield put({
            type: 'setUploadResult',
            payload: {
              statusCode: response.statusCode,
              fileUrl: response.fileUrl,
              chunks: response.chunks,
              msg: '上传成功',
            },
          });
          yield put({type:'setMultiFakeInfoUploading', payload:false});
        } else if (response.statusCode === 2) {
          // 失败
          yield put({
            type: 'setUploadResult',
            payload: {
              statusCode: response.statusCode,
              fileUrl: response.fileUrl,
              chunks: response.chunks,
              msg: '上传失败',
            },
          });
          yield put({type:'setMultiFakeInfoUploading', payload:false});
        }

      } else {
        yield put({
          type: 'setUploadResult',
          payload: {
            statusCode: 2, // 结果不对，认为上传失败，它的statusCode为2
            fileUrl: null,
            chunks: null,
            msg: '上传失败',
          },
        });

        yield put({type:'setMultiFakeInfoUploading', payload:false});
      }
    },

    // 虚假商户文件下载列表
    * getMultiFakeInfoList({ payload }, { call, put }) {
      yield put({
        type: 'setMultiFakeInfoListLoading',
        payload: true,
      });
      const response = yield call(getMultiFakeInfoList, payload,
        baseInfoErrorHandler);
      yield put({
        type: 'setMultiFakeInfoListLoading',
        payload: false,
      });
      console.warn(response);
      if (response) {
        yield put({
          type: 'setMultiFakeInfoList',
          payload: {
            pagination: {
              total: response.totalItems,
              current: response.currentPage + 1,  // 后端从0开始，antd表格从1开始
            },
            fakeInfoFileList: response.data,
          },
        });
      }
    },

  },

  reducers: {

    // 上传结果
    setUploadResult(state, action) {
      const {
        payload,
      } = action;
      return {
        ...state,
        uploadInfo: {
          ...payload,
          uploading: state.uploadInfo.uploading,
        }
      };
    },

    // 清除上传结果
    clearUploadResult(state, action) {
      return {
        ...state,
        uploadInfo: {
          uploading: state.uploadInfo.uploading,
        },
      };
    },

    // 虚假商户提交状态
    setMultiFakeInfoUploading(state, action) {
      return {
        ...state,
        uploadInfo: {
          ...state.uploadInfo,
          uploading: action.payload,
        },
      };
    },

    // 批量举报虚假商户文件下载列表的结果处理
    setMultiFakeInfoList(state, action) {
      const { pagination, fakeInfoFileList } = action.payload;
      const { total, current } = pagination;
      return {
        ...state,
        multiFakeInfo: {
          ...state.multiFakeInfo,
          pagination: {
            ...state.multiFakeInfo.pagination,
            total,
            current,
          },
          fakeInfoFileList,
        },
      };
    },

    // 下载列表加载中
    setMultiFakeInfoListLoading(state, action) {
      return {
        ...state,
        multiFakeInfo: {
          ...state.multiFakeInfo,
          loading: action.payload,
        },
      };
    },

  },

};
